<template>
  <HeadlessPopover v-slot="{ open: isOpen }" class="relative">
    <HeadlessPopoverButton
      ref="buttonRef"
      as="template"
      :is-open.camel
      @focus="handleFocus"
      @mousedown="handleMousedown"
    >
      <slot name="button" :is-open :toggle></slot>
    </HeadlessPopoverButton>

    <HeadlessPopoverPanel
      class="z-5 bg-bgr"
      :class="
        $screen.isSmall
          ? 'fixed top-0 left-0 right-0 bottom-0'
          : 'absolute mt-2 rounded-lg border border-bgr-300 shadow-lg'
      "
      @wheel="$screen.isSmall && $event.preventDefault()"
    >
      <slot :is-open :toggle></slot>
    </HeadlessPopoverPanel>
  </HeadlessPopover>
</template>

<script setup lang="ts">
import type { PopoverButton } from '@headlessui/vue'
import { isBoolean } from 'lodash-es'

defineExpose({ toggle })

const buttonRef = shallowRef<InstanceType<typeof PopoverButton>>()

const { focused } = useFocus(buttonRef)

const isClicking = ref(false)

function handleMousedown() {
  isClicking.value = !focused.value
}

function handleFocus() {
  isClicking.value = false
}

function toggle(value?: boolean | undefined) {
  if (isClicking.value) return

  const isOpen = !!buttonRef.value?.$attrs.isOpen

  if (isBoolean(value) && value === isOpen) return

  buttonRef.value?.$el.click()
}
</script>
